import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=6c303882&scoped=true&"
import script from "./Place.vue?vue&type=script&lang=ts&"
export * from "./Place.vue?vue&type=script&lang=ts&"
import style0 from "./Place.vue?vue&type=style&index=0&id=6c303882&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c303882",
  null
  
)

export default component.exports